import { safeAbsurd } from '@ipfabric/utils/types/safeAbsurd';
import { resolvedConfig } from './tailwindConfigResolved';

type ThemeSegment = 'colors' | 'textColor' | 'backgroundColor' | 'borderColor';

export const getTailwindColor = (
  colorPath: string,
  themeSegment: ThemeSegment = 'colors',
  opacity = 1,
): string | undefined => {
  let finalOpacity = opacity;

  // validate opacity
  if (finalOpacity < 0 || finalOpacity > 1) {
    safeAbsurd(
      colorPath as never,
      `Opacity must be between 0 and 1 for path '${colorPath}', fallback value 1 set`,
    );
    finalOpacity = 1;
  }

  const pathSegments = colorPath.split('.');
  let value = resolvedConfig.theme[themeSegment];

  for (const segment of pathSegments) {
    if (value && typeof value === 'object' && segment in value) {
      value = value[segment];
    } else {
      safeAbsurd(
        colorPath as never,
        `Color token for path '${colorPath}' not found, undefined returned as fallback`,
      );
      return undefined; // path does not exist
    }
  }

  if (typeof value === 'string') {
    if (value.includes('<alpha-value>')) {
      return value.replace('<alpha-value>', finalOpacity.toString());
    }
    return value;
  }

  return undefined;
};

export const formatCssVariable = (
  cssVarToken: string,
  colorValueType: 'rgbChannels' | 'hex' = 'rgbChannels',
  opacity = 1,
) => {
  return colorValueType === 'rgbChannels'
    ? `rgb(var(${cssVarToken}) / ${opacity})`
    : `var(${cssVarToken})`;
};
